import { createApp } from 'vue'
import App from './App.vue'
//import './assets/tailwind.css';
import router from './router';
import AOS from 'aos';

import "@/assets/theme/styles.css";

const app = createApp(App)

//app.use(createPinia())
app.use(router)

app.mount('#app')

// Initialize AOS
AOS.init();

